module.exports = __webpack_public_path__ + "static/media/nu_logo.9cca14d9.png";